import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { menuData } from '../data/menuData';
import './Sidebar.css';
import runopsLogo from '../assets/runops-logo.png';

const getInitials = (username) => {
  if (!username) return '...';
  const namePart = username.split('@')[0];
  return namePart.substring(0, 2).toUpperCase();
};

const Sidebar = ({ user, theme, toggleTheme, onLogout }) => {
  const [hoveredDomain, setHoveredDomain] = useState(null);
  const initials = getInitials(user?.username);

  const handleMouseEnter = (domain) => {
    setHoveredDomain(domain);
  };

  const handleMouseLeave = () => {
    setHoveredDomain(null);
  };

  const hoveredDomainData = menuData.find(d => d.title === hoveredDomain);

  return (
    <aside className="sidebar-slider" onMouseLeave={handleMouseLeave}>
      <div className="icon-bar">
        {/* <div className="sidebar-logo">
          <img src={runopsLogo} alt="RunOps AI Automation Logo" />
        </div> */}

        <nav className="icon-nav">
          {menuData.map(domain => (
            // Changed from NavLink to div to make it not clickable
            <div
              key={domain.title}
              className="icon-link" // Use a consistent class name
              onMouseEnter={() => handleMouseEnter(domain.title)}
            >
              <i className={domain.icon}></i>
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <a href="#" onClick={toggleTheme} title="Toggle Theme">
            {/* It changes between a moon and a sun based on the theme state */}
            <i className={theme === 'light' ? 'fas fa-moon' : 'fas fa-sun'}></i>
          </a>
           <a href="#" onClick={onLogout} title="Logout" className="logout-button">
                <i className="fas fa-sign-out-alt"></i>
            </a>
          <div className="sidebar-avatar" title={user?.username}>
            {initials}
          </div>
        </div>
      </div>

      <div className="flyout-menu">
        {hoveredDomainData && (
          <>
            <h3 className="flyout-title">{hoveredDomainData.title}</h3>
            <ul>
              {hoveredDomainData.children.map(submenu => (
                <li key={submenu.title}>
                  {/* These sub-menu items remain NavLinks so they are clickable */}
                  <NavLink to={submenu.path}>{submenu.title}</NavLink>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;